// extracted by mini-css-extract-plugin
export default {"detailGrid":"device-detail-form_detailGrid__a278d","formContainer":"device-detail-form_formContainer__u5SmX","padding":"device-detail-form_padding__lcFyP"};